import Tiptap from "./Tiptap";

export default Tiptap;
